import { USER } from 'src/auth/context/jwt/constant';

export function getCurrentUserId(): string | null {
  try {
    const userString = localStorage.getItem(USER);
    if (!userString) return null;

    const user = JSON.parse(userString);
    return user?.id || null;
  } catch (error) {
    return null;
  }
}
